<template>
  <div class="x-tablelist-view invoking" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @changeTime="changeTime"
      @change="change"
      @input="seach"
      @search="seach"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :emptyText="$t('HT.nodata')"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'date',
          daterange: true,
          event: 'changeTime'
        },
        {
          type: 'select',
          options: [],
          key: 'apiId',
          filterable: true,
          placeholder: 'API名称',
          event: 'change',
          props: {
            label: 'name',
            value: 'id'
          }
        },
        {
          type: 'input',
          key: 'keyword',
          placeholder: '请输入APP KEY进行搜索'
        }
      ],
      columns: [
        // 表头数据
        {
          label: '日期',
          prop: 'time',
          tooltip: true
        },
        {
          label: 'APP KEY',
          prop: 'app_key',
          tooltip: true
        },
        {
          label: 'API名称',
          prop: 'name',
          tooltip: true
          // formatter: (row, column, cellValue) => {
          //     return this.$opt.switchStr(cellValue, this.apiList, 'id', 'name');
          // },
        },
        {
          label: '调用次数',
          prop: 'total',
          tooltip: true
        },
        {
          label: '并发次数',
          prop: 'email',
          tooltip: true
        },
        {
          label: '路径',
          prop: 'uri',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        apiId: '', // api id
        keyword: '', // 名称
        startTime: '',
        endTime: '',
        page: 1,
        size: 10
      },
      filter2: {
        size: -1
      },
      apiList: [], // api 列表
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
    this.getApiList(this.filter2);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.statistics.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 获取API名称列表
     * @param {Object} params 请求参数
     */
    getApiList(params) {
      this.$api.api.getList(params).then((res) => {
        if (res.code == 10000) {
          this.apiList = this.layout[1]['options'] = res.data;
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    change() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 时间筛选
     * @param {Array} array 起始时间数组
     */
    changeTime(array) {
      this.filter.page = 1;
      this.filter.startTime = array[0].replace(/-/g, '/');
      this.filter.endTime = array[1].replace(/-/g, '/');
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
<style lang="scss">
.invoking {
  .x-option-selection {
    display: flex;
    align-items: center;
    height: 70px;
    min-height: 70px;

    .el-select {
      flex: 1;
      max-width: 150px;
      margin-right: 10px;
    }
  }
}
</style>
